import {EnglishTranslationsType} from "./enLocale";

const mkLocale: EnglishTranslationsType = {
    "e-mail": "Е-мејл адреса",
    "password": "Лозинка",
    "existing_user": "Постоечки корисник",
    "new_user": "Нов корисник",
    "forgot_password": "Заборавена лозинка",
    "login": "Најава",
    "bad_credentials": "Невалидна е-мејл адреса или лозинка.",
    "your_name": "Целосно име",
    "first_name": "Име",
    "last_name": "Презиме",
    "address": "Адреса",
    "register": "Регистрирај се",
    "accept_privacy_and_terms": "Ги прифаќам <0>Политиката за приватност</0> и <1>Условите и правилата</1>.",
    "read_more": "Прочитај повеќе",
    "or_login_with": "или најави се со",
    "field_required": "Ова поле е задолжително.",
    "email_field_not_valid": "Внеси валидна е-мејл адреса.",
    "choose_language": "Избери јазик",
    "home": "Почетна",
    "confirm_password": "Потврди лозинка",
    "confirmation_mail_message": "Испративме е-мејл за потврда на твојата адреса.",
    "log_out": "Одјави се",
    "wishes": "Желби",
    "about": "За нас",
    "logout_success": "Успешно се одјави",
    "sort_by": "Подреди по",
    "password_regex_not_valid": "Барањата за лозинка не се исполнети",
    "created_at": "Време на креирање",
    "end_time": "Преостанато време",
    "tickets_count": "Популарно",
    "times_read": "Прегледи",
    "search_wish": "Пребарај желба",
    "search": "Пребарај",
    "min": "Мин",
    "max": "Макс",
    "make_a_wish": "Посакај желба",
    "days": "Денови",
    "hours": "Часови",
    "minutes": "Минути",
    "seconds": "Секунди",
    "days_short": "Д",
    "hours_short": "Ч",
    "minutes_short": "Мин",
    "seconds_short": "Сек",
    "description": "Опис",
    "specification": "Спецификации",
    "admin_panel": "Админ панел",
    "client_panel": "Клиентски панел",
    "dashboard": "Контролна табла",
    "categories": "Категории",
    "questions": "Прашања",
    "category": "Категорија",
    "filters": "Филтри",
    "pending": "Во очекување",
    "active": "Активни",
    "finished": "Завршени",
    "no_data": "Нема податоци",
    "create_wish": "Креирај желба",
    "edit_wish": "Уреди желба",
    "close": "Затвори",
    "save": "Зачувај",
    "use": "Користи",
    "split_by_new_line": "Поделени по празен ред",
    "wish": "желба",
    "delete_wish_confirmation_message": "Дали си сигурен дека сакаш да ја избришеш желбата со ИД:",
    "publish_wish_confirmation_message": "Дали си сигурен дека сакаш да ја објавиш желбата со ИД:",
    "delete": "Избриши",
    "publish": "Објави",
    "reset": "Ресетирај",
    "create_category": "Креирај категорија",
    "delete_category_confirmation_message": "Дали си сигурен дека сакаш да ја избришеш категоријата со ИД:",
    "delete_category": "Избриши категорија",
    "scan_winner": "Скенирај добитник",
    "enter_info": "Внеси податоци",
    "upload_images": "Прикачи слики",
    "forgot_password_message": "Внеси ја твојата е-мејл адреса и ќе ти испратиме линк за ресетирање на лозинката.",
    "submit": "Испрати",
    "reset_password": "Ресетирај лозинка",
    "new_password": "Нова лозинка",
    "error_forgot_password": "Грешка при испраќање на е-мејл за ресетирање на лозинката. Обиди се повторно.",
    "forgot_password_success": "Испративме е-мејл за ресетирање на лозинката на {{email}}. Провери ја поштата и кликни на линкот.",
    "error_reset_password": "Грешка при ресетирање на лозинката. Обиди се повторно.",
    "reset_password_success": "Твојата лозинка е успешно променета.",
    "didnt_get_email": "Не доби е-мејл? Провери дали е-мејл адресата е точно внесена.",
    "resend": "Препрати",
    "change_email": "Промени е-мејл",
    "did_you_mean": "Дали мислеше",
    "link_expired": "Твојот линк е истечен или неважечки. Побарај нов.",
    "requirements": "Барања:",
    "eight_characters": "Најмалку 8 знаци",
    "include_lowercase": "Содржи мала буква",
    "include_uppercase": "Содржи голема буква",
    "include_special": "Содржи специјален знак",
    "your_profile": "Твој профил",
    "your_wishes": "Твои желби",
    "points": "Поени",
    "buy_now": "Купи сега",
    "edit_profile": "Ажурирај го профилот",
    "city": "Град",
    "phone_number": "Телефонски број",
    "update": "Ажурирај",
    "success_update_user": "Твојот профил е успешно ажуриран.",
    "error_update_user": "Настана грешка при ажурирање на твојот профил.",
    "vouchers": "Ваучери",
    "odds": "Шанси за добивка",
    "winners": "Добитници",
    "winners_announced_on": "Добитниците се објавени на {{date}}.",
    "you_are_one_of_lucky_winners": "Ти си еден од среќните добитници!",
    "you_are_not_one_of_lucky_winners": "Ти не си еден од среќните добитници.",
    "winner": "Добитник",
    "see_winners": "Види добитници ({{count}})",
    "login_register": "Најава / Регистрација",
    "see_more": "Види повеќе",
    "trending_draws": "Популарни извлекувања",
    "partner_vouchers": "Ваучери од партнерите",
    "partner_vouchers_subtitle": "Купувај ваучери од нашите партнери, уживај во нивните бенефити и освој Genie поени што ја намалуваат цената на учество во извлекувања.",
    "how_it_works": "Како работи?",
    "how_it_works_jsonld_description": "Следи ги чекорите за учество во извлекувања со ограничен број учества и зголеми ги шансите за добивка.",
    "home_how_it_works_subtitle": "Учествувај во извлекувања со ограничен број учества и освој големи награди. Со секое учество ги зголемуваш твоите шанси за добивка.",
    "past_winners": "Претходни добитници",
    "lets_begin": "Да започнеме",
    "start_wishing": "Оствари ја твојата желба",
    "register_now_and_start_wishing": "Регистрирај се и започни со посакување желби!",
    "learn_more": "Дознај повеќе",
    "learn_more_rules": "Дознај повеќе за нашите услови и правила",
    "passwords_not_match": "Лозинките не се совпаѓаат.",
    "wishlist": "Посакувани",
    "points_leaderboard": "Табела на поени",
    "cost": "Цена",
    "similar_wishes": "Слични желби",
    "back": "Назад",
    "something_went_wrong": "Настана грешка",
    "working_on_fixing_problem": "Работиме на решавање на проблемот",
    "refresh_page": "Освежи ја страницата",
    "available_vouchers": "Достапни ваучери",
    "bought_vouchers": "Купени ваучери",
    "obtained_entries": "Преземени учества",
    "category_popularity": "Популарност по категорија",
    "start_date": "Почетен датум",
    "end_date": "Краен датум",
    "bought_vouchers_per_category": "Купени ваучери по категорија",
    "percentage_total_bought": "Процент на купени ваучери / вкупно ваучери",
    "displayed_categories": "Прикажани категории",
    "users": "Корисници",
    "new_users": "Нови корисници",
    "proceed_to_payment": "Продолжи кон плаќање",
    "proceed_to_payment_short": "Кон плаќање",
    "obtain_more_entries_hint": "Зголеми ги шансите за добивка со купување на повеќе учества.",
    "continue": "Продолжи",
    "gender": "Пол",
    "male": "Машко",
    "female": "Женско",
    "wish_popularity_per_voucher_price": "Популарност на желба по цена",
    "voucher_popularity_per_points_award": "Популарност на ваучери според доделените поени",
    "users_per_gender": "Корисници по пол",
    "explore_more": "Истражи повеќе",
    "privacy": "Политика за приватност",
    "privacy_footer": "Приватност",
    "terms": "Услови и правила",
    "blogs": "Блогови",
    "contact": "Контакт",
    "legal": "Правни акти",
    "payment_methods": "Начини на плаќање",
    "trusted_partners": "Доверливи партнери",
    "secure_payments": "Безбедни плаќања преку доверливи провајдери.",
    "all_rights_reserved": "Сите права задржани.",
    "message": "Порака",
    "contact_us": "Контактирај нè",
    "why_genie": "Зошто Genie?",
    "success_create_contact": "Ти благодариме! Ја примивме твојата порака и ќе одговориме што е можно поскоро.",
    "error_create_contact": "Грешка при праќање на пораката. Обиди се повторно.",
    "load_more": "Прикажи повеќе",
    "responded": "Одговорено",
    "messages": "Пораки",
    "expenses": "Трошоци",
    "create_expense": "Креирај трошок",
    "update_expense": "Ажурирај трошок",
    "delete_expense": "Избриши трошок",
    "delete_expense_confirmation_message": "Дали си сигурен дека сакаш да го избришеш овој трошок?",
    "expenses_per_month": "Трошоци по месец",
    "price": "Цена",
    "delete_contact_confirmation_message": "Дали си сигурен дека сакаш да ја избришеш оваа порака?",
    "create_blog": "Креирај блог",
    "update_blog": "Ажурирај блог",
    "delete_blog_confirmation_message": "Дали си сигурен дека сакаш да го избришеш овој блог?",
    "buy_voucher_one": "Купи ваучер",
    "buy_voucher_other": "Купи ваучери",
    "confirm": "Потврди",
    "you": "Ти",
    "see_wish_details": "Детали за желбата",
    "error_occurred": "Настана грешка. Обиди се повторно.",
    "error_invalid_request_data": "Некои податоци не се валидни. Провери ги полињата и обиди се повторно.",
    "error_email_address_invalid": "Оваа е-мејл адреса изгледа невалидна. Провери ја и обиди се повторно.",
    "error_email_domain_not_found": "Не можеме да ја пронајдеме е-мејл домената. Провери дали е точно напишана (пример: gmail.com).",
    "error_email_delivery_failed": "Не успеавме да испратиме е-мејл на оваа адреса. Провери ја адресата или внеси друга.",
    "coming_soon": "Наскоро",
    "points_reward_tooltip": "Поени што се доделуваат за секој купен ваучер.",
    "page_not_found": "Страницата не е пронајдена",
    "page_not_exist": "Оваа страница не постои или е отстранета!",
    "suggest_home": "Ти предлагаме да се вратиш на почетна.",
    "bought": "Купени",
    "minimum": "Минимум",
    "maximum": "Максимум",
    "notifications": "Известувања",
    "mark_all_as_read": "Означи сè прочитано",
    "no_notifications": "Во моментов немаш известувања.",
    "only_unread": "Непрочитани",
    "subscribe_newsletter": "Сакам да добивам новости на е-мејл",
    "error_change_language": "Настана грешка при промена на јазикот.",
    "wheel_spins_dialog_title": "Дневно тркало на поени",
    "points_award_dialog_title": "Доделени поени",
    "points_congratulations_one": "Честитки! Доби {{count}} поен.",
    "points_congratulations_other": "Честитки! Доби {{count}} поени.",
    "spin_the_wheel": "Заврти го тркалото",
    "continue_browsing": "Сега можеш да продолжиш да ја користиш апликацијата.",
    "unsubscribe_success_title": "Отпиши се",
    "unsubscribe_success_question": "Дали си сигурен дека сакаш да се отпишеш од добивање новости на е-мејл?",
    "unsubscribe_success_description": "Успешно се отпиша од добивање новости на е-мејл.",
    "resubscribe_message": "Можеш повторно да се претплатиш со ажурирање на профилот.",
    "unsubscribe_error": "Грешка при отписот од добивање новости на е-мејл. Обиди се повторно.",
    "await_wish_draw": "Извлекувањето е во тек",
    "notification": "Известување",
    "send": "Испрати",
    "notification_send_success": "Известувањето е успешно испратено до избраните корисници.",
    "notification_send_error": "Грешка при испраќање на известувањето. Обиди се повторно.",
    "preview": "Преглед",
    "history_of_transactions": "Историја на трансакции",
    "transaction_id": "ИД на трансакција",
    "date": "Датум",
    "amount": "Износ",
    "status": "Статус",
    "PENDING": "ВО ОЧЕКУВАЊЕ",
    "SUCCESSFUL": "УСПЕШНА",
    "FAILED": "НЕУСПЕШНА",
    "contact_us_subtitle": "За проблеми или можности за соработка — ги цениме твоите повратни информации и со нетрпение очекуваме да стапиме во контакт.",
    "buy_vouchers_notice": "*Со купување ваучери, се согласуваш со <0>условите и правилата</0>. Купените ваучери за оваа желба може да се искористат до: {{expiry}}.",
    "profile_incomplete": "Твојот профил е нецелосен",
    "partners": "Партнери",
    "view_vouchers": "Види ваучери",
    "view_entries": "Види учества",
    "entry_id": "ИД на учество",
    "winner_voucher": "ДОБИТЕН",
    "non_winner_voucher": "НЕДОБИТЕН",
    "cookie_policy": "Користиме колачиња за аналитика и маркетинг — повеќе во нашата <0>Политика за приватност</0>.",
    "accept": "Прифати",
    "available": "Достапни",
    "obtained": "Преземени",
    "terminate_wish_confirmation_message": "Дали си сигурен дека сакаш да ја прекинеш желбата со ИД:",
    "terminate": "Прекини",
    "terminated": "Прекинати",
    "scan_again": "Скенирај повторно",
    "all_vouchers_bought": "Нема достапни ваучери.",
    "all_entries_obtained": "Нема достапни учества.",
    "url_copied": "Адресата е копирана",
    "other": "Друго",
    "create_update_document": "Креирај / Ажурирај документ",
    "documents": "Документи",
    "who_are_we": "Кои сме ние?",
    "add_new": "Додај нов",
    "effective": "На сила од:",
    "images": "Слики",
    "delete_image_confirmation_message": "Дали си сигурен дека сакаш да ја избришеш оваа слика?",
    "config": "Конфигурација",
    "changes_saved_success": "Промените се успешно зачувани.",
    "create_update_config": "Креирај / Ажурирај конфигурација",
    "announced": "Објавено на:",
    "reschedule_wish_confirmation_message": "Дали си сигурен дека сакаш да го презакажеш извлекувањето за желбата со ИД:",
    "reschedule": "Презакажи",
    "enter_amount": "Внеси износ",
    "payment": "Плаќање",
    "confirmation": "Потврда",
    "or_enter_custom_amount": "или внеси сопствен износ",
    "minimum_amount": "Минималниот износ е {{minimum}}",
    "faq": "Често поставувани прашања",
    "faq_short": "ЧПП",
    "check_faq_short": "Провери ги нашите <0>често поставувани прашања</0> за одговори. Ако сè уште ти треба помош, испрати ни порака подолу!",
    "still_not_clear": "Сè уште имаш прашања? Провери ги нашите <0>често поставувани прашања</0> или <1>испрати ни порака</1> за дополнителна помош!",
    "congratulations": "Честитки!",
    "you_are_the_lucky_winner": "{{fullName}}, ти си меѓу среќните добитници на {{wishName}}!",
    "our_team_will_contact_you": "Нашиот тим ќе те контактира со детали како да ја подигнеш наградата.",
    "this_qr_code_must_be_presented": "*Овој QR-код мора да се прикаже за да ја подигнеш наградата.",
    "install": "Инсталирај",
    "get_for_seamless_experience": "Преземи ја Genie апликацијата за беспрекорно искуство!",
    "claim_prize": "Подигни награда",
    "expand": "Прошири",
    "collapse": "Собери",
    "this_month": "Овој месец",
    "January": "Јануари",
    "February": "Февруари",
    "March": "Март",
    "April": "Април",
    "May": "Мај",
    "June": "Јуни",
    "July": "Јули",
    "August": "Август",
    "September": "Септември",
    "October": "Октомври",
    "November": "Ноември",
    "December": "Декември",
    "no_active_wishes_title": "Немаш активни желби",
    "no_active_wishes_subtitle": "Активните желби во кои учествуваш ќе се појават овде. Истражи повеќе желби сега!",
    "no_finished_wishes_title": "Немаш завршени желби",
    "no_finished_wishes_subtitle": "Завршените желби во кои си учествувал ќе се појават овде. Истражи повеќе желби сега!",
    "no_wishlist_wishes_title": "Немаш посакувани желби",
    "no_wishlist_wishes_subtitle": "Желбите што ќе ги зачуваш ќе се појават овде. Истражи повеќе желби сега!",
    "explore_wishes": "Истражи желби",
    "send_as_gift": "Испрати како подарок",
    "send_voucher_as_gift_tooltip": "Разубави му го денот на некого со ваучер! Внеси име и е-мејл, а тие ќе добијат порака со упатства како да го искористат подарокот.",
    "send_entry_as_gift_tooltip": "Разубави му го денот на некого со учество! Внеси име и е-мејл, а тие ќе добијат порака со упатства како да го искористат подарокот.",
    "recipient_email": "Е-мејл на примачот",
    "recipient_name": "Име на примачот",
    "personalized_message": "Персонализирана порака",
    "or_enter_manually": "или внеси рачно",
    "voucher_code": "Код на ваучерот",
    "help": "Помош",
    "guide": "Водич",
    "discover_guide_text": "Истражи го Genie водичот",
    "explore": "Истражи",
    "check_out_wish": "Погледни ја оваа желба — мислам дека ќе ти се допадне!",
    "unsaved_changes_message": "Имаш незачувани промени. Ако продолжиш, ќе ги изгубиш. Дали си сигурен?",
    "email_send_success": "Е-мејлот е успешно испратен.",
    "email_send_error": "Грешка при испраќање е-мејл. Обиди се повторно.",
    "e-mails": "Е-мејлови",
    "optional_fields": "Опционални полиња",
    "spin_the_wheel_explanation": "Освен што собираш поени со купување ваучери, можеш да го завртиш тркалото еднаш дневно и да освоиш дополнителни поени.",
    "coming_soon_title": "Желбите наскоро стануваат реалност!",
    "coming_soon_subtitle": "Биди меѓу првите кои ќе бидат во тек со сите информации и новости!",
    "giveaway_note": "Можеш да учествуваш само еднаш во овој giveaway.",
    "redraw_winners_confirmation_message": "Дали си сигурен дека сакаш повторно да избереш добитници за желбата со ИД:",
    "already_participated": "Веќе учествуваш во овој giveaway.",
    "app_description": "Освој големи награди во извлекувања со ограничен број учества, а со купување ваучери од партнерите собирај Genie поени што ти ја намалуваат цената на учество.",
    "app_keywords": "Genie, извлекувања, наградни игри, ограничен број учества, големи награди, ваучери од партнери, Genie поени, учества, giveaway",
    "app_jsonld_description": "Genie е веб-платформа фокусирана на извлекувања со ограничен број учества. Корисниците купуваат учества за да се натпреваруваат за големи награди, а можат и да купуваат ваучери од партнери за бенефити и Genie поени што ја намалуваат цената на учество во извлекувања.",
    "genie_name": "Genie",
    "clients": "Клиенти",
    "update_client": "Ажурирај клиент",
    "create_client": "Креирај клиент",
    "validate_voucher": "Валидирај ваучер",
    "validate_again": "Валидирај повторно",
    "total": "Вкупно",
    "expired": "Истечени",
    "redeemed": "Искористени",
    "details": "Детали",
    "bank_fee": "Банкарска провизија",
    "expires": "Истекува",
    "active_voucher": "Активен",
    "expired_voucher": "Истечен",
    "redeemed_voucher": "Искористен",
    "draw": "Извлекување",
    "draws": "Извлекувања",
    "comment": "Коментар",
    "leave_a_comment": "Опционално: Остави коментар за твојата неодамнешна валидација",
    "leave_comment_success": "Коментарите за ваучерите можеш да ги најдеш во клиентскиот панел.",
    "select_wish_to_start": "Избери желба за да започнеш.",
    "no_vouchers_yet": "Сè уште немаш ваучери.",
    "no_wishes_yet": "Сè уште немаш желби.",
    "no_draws_yet": "Сè уште немаш извлекувања.",
    "update_comment": "Ажурирај коментар",
    "client_vouchers_bought": "{{bought}}/{{total}} купени ваучери",
    "client_entries_obtained": "{{obtained}}/{{total}} преземени учества",
    "voucher": "Ваучер",
    "duplicate_wish_confirmation_message": "Дали си сигурен дека сакаш да ја дуплираш желбата со ИД:",
    "duplicate": "Дуплирај",
    "entries": "Учества",
    "question_step": "Прашање",
    "create_question": "Креирај прашање",
    "update_question": "Ажурирај прашање",
    "delete_question": "Избриши прашање",
    "delete_question_confirmation_message": "Дали сте сигурни дека сакате да го избришете прашањето со ID:",
    "answers": "Одговори",
    "add_answer": "Додај одговор",
    "correct_answer": "Точен одговор",
    "question_list_error": "Грешка при вчитување на прашањата. Обидете се повторно.",
    "question_form_invalid": "Пополнете ги сите полиња и означете еден точен одговор.",
    "question_create_success": "Прашањето е успешно креирано.",
    "question_create_error": "Грешка при креирање на прашањето. Обидете се повторно.",
    "question_update_success": "Прашањето е успешно ажурирано.",
    "question_update_error": "Грешка при ажурирање на прашањето. Обидете се повторно.",
    "question_delete_success": "Прашањето е успешно избришано.",
    "question_delete_error": "Грешка при бришење на прашањето. Обидете се повторно.",
    "paying_users": "Корисници со уплата",
    "answer_question_to_continue": "Одговори точно за да продолжиш кон наплата.",
    "question_unavailable": "Прашањето моментално не е достапно. Вчитај ново прашање.",
    "incorrect_answer_message": "Неточен одговор. Не можеш да продолжиш со ова прашање.",
    "question_answer_wrong_title": "Погрешен одговор",
    "question_answer_wrong_message": "Одговорот не беше точен, па не можеш да продолжиш кон наплата.",
    "question_answer_wrong_hint": "Затвори го овој прозорец и пробај повторно со ново прашање.",
    "new_question": "Ново прашање",
    "obtain_entries_confirmation_one": "Дали си сигурен дека сакаш да учествуваш со {{count}} учество за {{wishName}}?",
    "obtain_entries_confirmation_other": "Дали си сигурен дека сакаш да учествуваш со {{count}} учества за {{wishName}}?",
    "success_gift_obtain_entries_one": "Успешно подари {{count}} учество за оваа желба.",
    "success_gift_obtain_entries_other": "Успешно подари {{count}} учества за оваа желба.",
    "success_obtain_entries_one": "Успешно презема {{count}} учество за оваа желба. Среќно!",
    "success_obtain_entries_other": "Успешно презема {{count}} учества за оваа желба. Среќно!",
    "obtain_entries_notice": "*Со учество во оваа желба, секој учесник се согласува со <0>условите и правилата</0>.",
    "not_enough_points_message_one": "Немаш доволно Genie поени за да учествуваш со {{count}} учество за {{wishName}}. Моментално имаш {{currentPoints}} поени и ти недостигаат уште {{missingPoints}}.",
    "not_enough_points_message_other": "Немаш доволно Genie поени за да учествуваш со {{count}} учества за {{wishName}}. Моментално имаш {{currentPoints}} поени и ти недостигаат уште {{missingPoints}}.",
    "cost_genie_points_one": "Ова ќе чини {{count}} Genie поен.",
    "cost_genie_points_other": "Ова ќе чини {{count}} Genie поени.",
    "all": "Сите",
    "wish_type": "Тип на желба",
    "available_points": "Достапни поени",
    "subtotal": "Меѓузбир",
    "points_discount": "Попуст со поени",
    "use_points_for_discount": "Искористи поени за намалување на вкупната цена",
    "points_conversion_rate": "1 Genie поен = 1 MKD",
    "points_to_use": "Поени за користење",
    "max_points_to_use": "Можеш да искористиш најмногу {{count}} поени.",
    "spin_again": "Врати се за {{timeLeft}} за ново вртење!",
    "points_to_use_tooltip": "Достапни Genie поени што можеш да ги искористиш како попуст при наплата за извлекувања (1 Genie поен = 1 MKD).",
    "start_and_free_points": "Регистрирај се сега и добиј {{points}} поени бесплатно",
    "no_active_wishes": "Нема активни желби. Провери подоцна!",
    "no_active_wishes_from_type": "Нема активни желби од овој тип. Провери подоцна!",
    "free_entry": "Бесплатно учество",
    "free_voucher": "Бесплатен ваучер",
    "wish_has_finished": "Оваа желба заврши",
    "ios_install": "Само притисни <0></0> и „Add to Home Screen“ за да ја инсталираш.",
    "view_points_history": "Преглед на историја на поени",
    "change": "Промена",
    "title": "Назив",
    "genie_points": "Genie поени",
    "points_used": "Искористени поени",
    "gift_label": "Подарок",
    "disable_client_user": "Деактивирај клиент-корисник",
    "disable_client_user_confirmation_message": "Дали си сигурен дека сакаш да деактивираш клиент-корисник со ИД: {{id}}",
    "disable_client_user_success": "Успешно го деактивираше клиент-корисникот",
    "generate_report": "Генерирај извештај",
    "download": "Преземи",
    "profit": "Профит",
    "income": "Приход",
    "profit_per_month": "Профит по месец",
    "all_time": "Вкупно",
    "expenses_per_category": "Трошоци по категорија",
    "all_cities": "Сите градови",
    "related_vouchers_message": "Пронајдовме дополнителни ваучери поврзани со овој код. Изберете ги оние што сакате да ги валидирате:",
    "validate": "Валидирај",
    "location": "Локација",
    "options": "Опции",
    "from": "од",
    "left": "{{count}} преостанати",
    "upload_codes": "Прикачи кодови",
    "update_category": "Ажурирај категорија",
    "choose_option": "Избери опција",
    "obtain_voucher": "Преземи ваучер",
    "already_obtained_voucher": "Веќе имаш активен ваучер.",
    "obtain_voucher_notice": "*Со преземањето на овој ваучер се согласуваш со <0>условите и правилата</0>. Преземениот ваучер за оваа желба може да се искористи до: {{expiry}}.",
    "obtain_free_voucher_confirmation": "Дали си сигурен дека сакаш да го преземеш овој ваучер за „{{wish_name}}“?",
    "free_voucher_note": "Можеш да имаш само еден активен ваучер за оваа желба истовремено.",
    "prize_stay_tuned": "Остани во тек за наградата",
    "success_obtain_free_voucher": "Успешно го презема ваучерот за оваа желба.",
    "prize_draw": "Наградна игра",
}

export default mkLocale
